import { FIELDS_MAPPING } from "@/utils/constants/allFieldsMapping";

type FieldsMappingKey = keyof typeof FIELDS_MAPPING;

export type EntityFieldGroupKey = FieldsMappingKey;

export const ENTITY_TYPE_FIELD_GROUPS: Record<string, FieldsMappingKey[]> = {
  Group: ["groupDetails"],
  Brand: ["brandDetails", "brandContacts", "brandMenu"],
  Branch: [
    "branchDetails",
    "branchHours",
    "branchVibes",
    "branchAmenities",
    "branchMedia",
    "branchSetup",
    "branchReceiptPicture",
    "branchPOS",
    "branchBoost",
    "branchMenu",
  ],
  "Legal Entity": ["legalEntity"],
  Tag: ["tags"],
  Collection: ["collectionDetail"],
  FAQ: ["faqDetails"],
  Diner: ["dinerDetails"],
  Tier: ["tierDetails"],
  "Referral Rule": ["referralRuleDetails"],
  "Cashback Override": ["cashbackOverrideDetails"],
  "Cashback Item Exclusion": ["cashbackItemExclusionDetails"],
  "Admin Team": ["adminUserDetails"],
  "Admin Team Role": ["adminTeamRole"],
  "Portal User": ["portalUserDetails"],
  "Portal User Role": ["portalTeamRole"],
  "Funding Request": ["fundingTransferDetails"],
  "Settlement Transfer": ["settlementTransfers"],
  "Refund Request": ["refundDetails"],
  "Top-Up Request": ["dinerTopUpsDetails"],
  "POS Integration": ["branchPOS"],
  "Menu Dish": ["brandMenuDish"],
  Menu: ["brandMenu"],
  "Menu Category": ["menuCategories"],
};

const buildFieldsMapping = (
  groupKeys: FieldsMappingKey[]
): Record<string, string> =>
  groupKeys.reduce<Record<string, string>>(
    (acc, key) => ({ ...acc, ...FIELDS_MAPPING[key] }),
    {}
  );

export const MENU_HISTORY_FIELD_GROUPS: FieldsMappingKey[] = [
  "brandMenu",
  "brandMenuDish",
  "menuCategories",
];

export const MENU_HISTORY_FIELDS_MAPPING = buildFieldsMapping(
  MENU_HISTORY_FIELD_GROUPS
);

export const getEntityFieldsMapping = (
  entityType: string
): Record<string, string> => {
  const groupKeys = ENTITY_TYPE_FIELD_GROUPS[entityType];

  if (!groupKeys) {
    return {};
  }

  return buildFieldsMapping(groupKeys);
};
